/* eslint-disable max-len */
export default {
  parsePagination(pager) {
    return {
      page: pager.page,
      // eslint-disable-next-line no-underscore-dangle
      items: pager._embedded
        ? pager._embedded[Object.keys(pager._embedded)[0]]
        : pager.content
        ? pager.content
        : []
    };
  },
  generateDiscussionObject(data, mergeRequest) {
    let lines;
    if (data.line && data.line.id) lines = data.line.id.split('-');

    const output = {
      newLine: lines ? lines[2] : null,
      oldLine: lines ? lines[1] : null,
      baseCommit: mergeRequest.targetBranch.hash,
      targetCommit: mergeRequest.targetBranch.hash,
      startCommit: mergeRequest.sourceBranch.hash,
      newPath: data.file ? data.file.newPath : null,
      oldPath: data.file ? data.file.oldPath : null,
      message: data.data.trim(),
      entityUUID: mergeRequest.id
    };

    if (data.discussion) {
      output.discussionUuid = data.discussion.id;
    }

    return output;
  },
  getRealPagination(object) {
    if (!object) return {};
    return { ...object, page: object.page ? object.page - 1 : null };
  },
  changePaginationCount(pager, change) {
    pager.page.totalElements += change;
    pager.page.totalPages = pager.page.totalElements % pager.page.size;
    return pager;
  },
  copyCodeTransform(data) {
    return `\`\`\`\n${data
      .toString()
      .split('\n')
      .map((item) => item.replace(/^[+]\t/g, '').replace(/^[0-9]+\t/g, ''))
      .join('\n')}\n\`\`\``;
  },
  getQueryParamsFromURL() {
    return {
      params: new URLSearchParams(window.location.search)
    };
  },

  // Функция деструктуризации объекта любой вложенности
  destructureObject(obj, prefix = '') {
    if (!obj) return;

    const result = {};

    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(obj)) {
      const newKey = prefix ? `${prefix}.${key}` : key;

      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        Object.assign(result, this.destructureObject(value, newKey));
      } else {
        result[newKey] = value;
      }
    }

    // eslint-disable-next-line consistent-return
    return result; // Вернет объект
  },

  // Функция фильтрации объекта (Возвращает объект, только с теми полями, которые были переданы в качестве аргумента)
  filterObjectOrArrayOfObjects(input, fieldsToKeep) {
    // Фильтрация одного объекта
    const filterObject = (obj) =>
      Object.fromEntries(
        Object.entries(obj)
          .map(([key, value]) => {
            // Если значение - это объект, рекурсивно фильтруем его
            if (isObject(value)) {
              return [key, filterObject(value)];
            }
            // Если ключ нужно сохранить, то оставляем его
            if (fieldsToKeep.includes(key)) {
              return [key, value];
            }
            // Если ключ не нужно сохранять, возвращаем пустой массив (будет отфильтровано)
            return [];
          })
          .filter((entry) => entry.length > 0) // Чистим undefined ключи и undefined значения
      );

    const isObject = (value) => value && typeof value === 'object' && !Array.isArray(value);

    // Если на входе массив объектов -> каждый объект в массиве прогоняем через фильтр и возвращаем результат
    if (Array.isArray(input)) {
      return input.map(filterObject);
    }

    // Если на вход подан один объект
    if (isObject(input)) {
      return filterObject(input);
    }

    console.error(
      'Invalid input for function "filterObjectOrArrayOfObjects", expected "input" as { Object / Array( Object1, Object2, ... ) / Object( Object1, Object2, ... ) } and "fieldsToKeep" as { Array( fieldName1, fieldName2, ... ) }'
    );
    return null;
  },
  // Функция, кодирующая файл в BASE64 строку (использовали когда в форме нужно было передавать - multipart/form-data и application/json)
  // Пример использования: project.import.vue
  encodeFileIntoBase64String(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsArrayBuffer(file);

      reader.onload = function () {
        const bytes = new Uint8Array(reader.result);
        let binary = '';
        for (let i = 0; i < bytes.byteLength; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        const base64String = btoa(binary);
        resolve(base64String);
      };

      reader.onerror = function (error) {
        reject(error);
      };
    });
  },
  translitString(string) {
    const ru = {
      а: 'a',
      б: 'b',
      в: 'v',
      г: 'g',
      д: 'd',
      е: 'e',
      ё: 'e',
      ж: 'j',
      з: 'z',
      и: 'i',
      к: 'k',
      л: 'l',
      м: 'm',
      н: 'n',
      о: 'o',
      п: 'p',
      р: 'r',
      с: 's',
      т: 't',
      у: 'u',
      ф: 'f',
      х: 'h',
      ц: 'c',
      ч: 'ch',
      ш: 'sh',
      щ: 'shch',
      ы: 'y',
      э: 'e',
      ю: 'u',
      я: 'ya'
    };
    const nStr = [];

    const newString = string
      .toLowerCase()
      .replace(/[ъь]+/g, '')
      .replace(/й/g, 'i')
      .replace(/ /g, '-');

    for (let i = 0; i < newString.length; ++i) {
      nStr.push(
        ru[newString[i]] ||
          (ru[newString[i].toLowerCase()] === undefined && newString[i]) ||
          ru[newString[i].toLowerCase()].toUpperCase()
      );
    }

    return nStr.join('');
  },
  copy(text) {
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      const textArea = document.createElement('textarea');
      textArea.disabled = true;
      textArea.value = text;
      textArea.style.opacity = 0;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand('copy');
      } catch (err) {
        console.log(err);
      }
    }
  },
  share(data) {
    let isShared = false;
    if (navigator?.share) {
      isShared = true;
      navigator.share(data).catch((err) => {});
    } else {
      this.copy(window.location.origin + data?.url);
      isShared = false;
    }
    return isShared;
  },
  formatOutputNumber(number, digits) {
    const abbreviations = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: ' тыс' },
      { value: 1e6, symbol: ' млн' },
      { value: 1e9, symbol: ' млрд' }
    ];

    const regexp = /\.0+$|(\.[0-9]*[1-9])0+$/;

    const item = [...abbreviations].reverse().find((element) => number >= element.value);

    if (!item) return '0';

    const formatted = (number / item.value).toFixed(digits).replace(regexp, '$1');
    return formatted + item.symbol;
  },

  /*
  Имя: getValueForCurrentMediaBreakPoint
  Параметры: valuesToReturn {
    sm, md, lg, xl: Значение которое должно вернуться при @media (max-width: [sm, md, lg, xl])
    coefficient: Значение, на которое будет делиться ширина экрана, в момент выхода за пределы xl (default: 50)
    base: Значение, которое вернется при отсутствии значения для одного из брейкпоинтов
  }
*/
  getValueForCurrentMediaBreakPoint(valuesToReturn) {
    const getCSSVar = (varName) => {
      const rootStyle = getComputedStyle(document.documentElement);
      return rootStyle.getPropertyValue(varName).trim();
    };
    if (!valuesToReturn) {
      console.error('Invalid input for function getValueForCurrentMediaBreakPoint');
    }
    if (
      window.matchMedia(`(max-width: ${getCSSVar('--breakpoint-sm-max')})`).matches &&
      valuesToReturn.sm
    ) {
      return valuesToReturn.sm;
    }
    if (
      window.matchMedia(`(max-width: ${getCSSVar('--breakpoint-md-max')})`).matches &&
      valuesToReturn.md
    ) {
      return valuesToReturn.md;
    }
    if (
      window.matchMedia(`(max-width: ${getCSSVar('--breakpoint-lg-max')})`).matches &&
      valuesToReturn.lg
    ) {
      return valuesToReturn.lg;
    }
    if (
      window.matchMedia(`(max-width: ${getCSSVar('--breakpoint-xl-max')})`).matches &&
      valuesToReturn.xl
    ) {
      return valuesToReturn.xl;
    }
    if (
      window.matchMedia(`(min-width: ${getCSSVar('--breakpoint-xl-max')})`).matches &&
      valuesToReturn.xl
    ) {
      const windowWidth = window.innerWidth;
      return (
        valuesToReturn.xl +
        Math.floor(
          (windowWidth - parseInt(getCSSVar('--breakpoint-xl-max'), 10)) /
            (valuesToReturn.coefficient || 50)
        )
      );
    }
    return valuesToReturn.base;
  },

  /* Обрезка текста по центру
  Имя: truncateContentFromCenter
  Параметры:
  text - исходный текст
  params: {
    limitBase - базовая допустимая длина результата обрезки 'text'
    limitSm, limitMd, limitLg, limitXl - допустимые длины результата обрезки для соответствующих брейкпоинтов
    replacement - строка, которая заменит обрезанную часть текста
    separator - строка, по которой содержимое будет разбиваться на сегменты
  }
*/
  truncateContentFromCenter(
    text,
    params = {
      limitBase: 10,
      limitSm: limitBase,
      limitMd: limitBase,
      limitLg: limitBase,
      limitXl: limitBase,
      coefficient: 50,
      replacement: '...',
      separator: ''
    }
  ) {
    // Вычисление максимально допустимой длины обрезанного текста
    const limitTextLength = this.getValueForCurrentMediaBreakPoint({
      sm: params.limitSm,
      md: params.limitMd,
      lg: params.limitLg,
      xl: params.limitXl,
      coefficient: params.coefficient,
      base: params.limitBase
    });

    // Основной скрипт с обрезкой текста
    const truncate = (text, limitLength, replacement, separator) => {
      if (text.length <= limitLength) return text;

      if (separator !== '') {
        const parts = text.split(separator);

        if (parts.length <= 3) {
          return text;
        }

        return (
          parts[0] +
          separator +
          parts[1] +
          separator +
          replacement +
          separator +
          parts[parts.length - 1]
        );
      }

      const charsToShow = limitLength - replacement.length;
      const frontChars = Math.ceil(charsToShow / 2);
      const backChars = Math.floor(charsToShow / 2);

      return text.substr(0, frontChars) + replacement + text.substr(text.length - backChars);
    };

    const truncatedText = truncate(
      text.trim(),
      limitTextLength,
      params.replacement,
      params.separator
    );

    return truncatedText;
  },

  formatedFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = 0;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
  },

  // Вырезка кириллицы
  removeCyrillicCharacters(value) {
    const newValue = value.replace(/[А-Яа-яЁё]/g, '');
    return newValue;
  }
};
